import { isEmpty } from "@/main/services/utils";
import colors from "@/main/style/colors";
import styled, { css } from "styled-components";

interface IContainerProps {
	$isThreeColumns?: boolean;
	$showShippingColumn?: boolean;
}

const HEIGHT_IMAGE_PART = "55px";
export const Container = styled.div<IContainerProps>`
	position: relative;
	display: grid;
	align-items: center;
	grid-template-columns: ${(props) =>
		props.$isThreeColumns
			? `${HEIGHT_IMAGE_PART} 430px 1fr 140px 220px 80px`
			: `${HEIGHT_IMAGE_PART} 430px 1fr 220px 80px`};
	gap: 1rem;
	border-bottom: 1px solid #ccc;
	border-radius: 4px 4px 0 0;
	min-height: ${HEIGHT_IMAGE_PART};

	> img {
		width: 100%;
		max-width: 70px;
		height: ${HEIGHT_IMAGE_PART};
		object-fit: contain;
	}

	p {
		margin: 0;
	}
	transition: background-color 0.3s;

	&:hover {
		background-color: #fafafa;
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.desktopSmall}) {
		grid-template-columns: ${(props) =>
			props.$isThreeColumns ? "70px minmax(170px, 1fr) 1fr 90px 100px 25px" : "70px minmax(170px, 1fr) 1fr 100px 25px"};
	}
	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		grid-template-columns: 1fr;
	}
	@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
		gap: 0.4rem;
		> img {
			margin: 0 auto 0 0;
		}
		p {
			text-align: left !important;
		}
	}

	@media (min-width: 1800px) {
		grid-template-columns: ${(props) =>
			props.$isThreeColumns ? "70px 2fr repeat(3, 1fr) 80px" : "70px 2fr 1fr 1.3fr 80px"};
	}

	${(props) =>
		props.$showShippingColumn &&
		css`
			grid-template-columns: ${props.$isThreeColumns
				? `${HEIGHT_IMAGE_PART} 3fr 1fr 140px 115px 230px 75px`
				: `${HEIGHT_IMAGE_PART} 3fr 1fr 115px 230px 75px`};

			@media (max-width: ${({ theme }) => theme.breakpoints.desktopSmall}) {
				grid-template-columns: ${props.$isThreeColumns
					? "70px minmax(170px, 1fr) 1fr 90px 100px 75px 25px"
					: "70px minmax(170px, 1fr) 1fr 100px 75px 25px"};
			}
			@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
				grid-template-columns: 1fr;
			}
			@media (min-width: 1800px) {
				grid-template-columns: ${props.$isThreeColumns
					? "70px 3fr 1fr 2fr 1fr 1.3fr 80px"
					: "70px 3fr 1fr 2fr repeat(1, 1fr) 80px"};
			}
		`}
`;

interface ILabelCenterProps {
	$delayed?: boolean;
}
export const LabelCenter = styled.p<ILabelCenterProps>`
	margin: 0;
	text-align: center;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		text-align: left;
	}

	${({ $delayed }) =>
		$delayed &&
		css`
			color: ${colors.red};
		`}
`;

export const AreaDateWithDelayIcon = styled.div`
	display: grid;
	grid-template-columns: 1fr 35px;
	align-items: center;
	row-gap: 0.25rem;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		grid-template-columns: auto 35px;
		justify-content: start;
	}
`;

export const AreaDateBackOrderBadge = styled.div`
	grid-column: 1;
	justify-self: center;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		justify-self: start;
	}
`;

export const AreaIconDeadline = styled.div`
	display: flex;
	align-items: center;
`;

export const AreaPrice = styled.div`
	text-align: right;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		text-align: left;
	}
`;

export const TotalPrice = styled.p`
	font-size: 1rem;
	font-weight: bold;
	margin: 0;
	word-break: break-word;
	text-align: right;

	@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
		text-align: left;
	}
`;

export const Quantity = styled.div`
	border: 1px solid ${({ theme }) => theme.pantone2726C};
	width: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 20%;
`;

export const AreaTitlePart = styled.div`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;
export const Column = styled.div`
	display: grid;
	grid-template-columns: 1fr 30px;
	gap: 0.2rem;

	& > *:nth-child(2) {
		width: 30px;
	}
`;
export const ColumnQuantity = styled.div`
	display: grid;
	grid-template-columns: 1fr 30px;
	gap: 1rem;

	& > *:nth-child(2) {
		width: 30px;
	}
`;

export const TextCenter = styled.p`
	text-align: center;
`;

export const ButtonConfirmProcess = styled.button`
	text-align: center;
	margin: 0 auto;
	display: block;
	color: ${({ theme }) => theme.pantone2726C};
	border: 1px solid ${({ theme }) => theme.pantone2726C};
	border-radius: 8px;
	background-color: transparent;
	padding: 2px 10px;
	margin-top: 5px;

	&:disabled {
		opacity: 0.8;
		cursor: wait;
	}
`;

export const AreaReason = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	text-align: center;

	> p {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		width: 100%;
		max-width: 280px;
	}
	@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
		align-items: flex-start;

		> p {
			max-width: 200px;
		}
	}
`;

export const AreaBackOrderBadge = styled.div`
	margin-top: 0.25rem;
`;

export const AreaReasonTooltip = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	text-align: center;
`;

interface ICollumnStatusProps {
	$color?: string;
}
export const CollumnStatus = styled.div<ICollumnStatusProps>`
	text-align: center;
	${({ $color }) =>
		!isEmpty($color) &&
		css`
			color: ${$color};
		`}
`;

export const AreaTooltipDates = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
`;

export const CollumnShipping = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.2rem;
	text-align: center;
	max-width: 120px;
	overflow: hidden;

	> span {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;

export const AreaTooltipShipping = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
`;
